import type { ReactNode } from 'react'
import { Inspiration, M_PLUS_1p } from 'next/font/google'
import ScamAlert from '@/components/scam-alert'
// import SupportModal from '@/components/support/modal'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import Footer from './footer'
import Header from './header'

// M PLUS 1p は日本語フォントのため、Google Fonts 側で unicode-range ごとに
// 126 分割 × 3 ウェイト = 378 個の @font-face に分かれている。
// preload を有効にすると全 240 ファイル（約 2MB）が <link rel="preload"> として
// 高優先度で先読みされ、LCP 画像や JS の帯域を奪ってしまう。
// preload: false にすると、ブラウザが実際に描画に必要な slice だけを遅延取得する。
const mPlus1p = M_PLUS_1p({
  subsets: [ 'latin' ],
  weight: [ '500', '700', '800' ],
  variable: '--font-m-plus-1p',
  preload: false,
  display: 'swap',
})

const inspiration = Inspiration({
  subsets: [ 'latin' ],
  weight: '400',
  variable: '--font-inspiration',
  display: 'swap',
})
interface Props {
  children: ReactNode
  hideLogin?: boolean
  hideLayout?: boolean
}

const Layout = ({ children, hideLogin = false, hideLayout = false }: Props) => {
  if (hideLayout) return <>{children}</>
  return (
    <TooltipProvider delayDuration={200}>
      <div
        vaul-drawer-wrapper=""
        className={`ols-app flex min-h-screen flex-col ${mPlus1p.variable} ${inspiration.variable}`}
      >
        <div className="relative grow">
          <Header hideLogin={hideLogin} />
          <ScamAlert />
          {children}
        </div>
        <Footer />
      </div>
      {/* <SupportModal /> */}
      <Toaster />
    </TooltipProvider>
  )
}

export default Layout
